'use strict';
import React from 'react';
import leaveAction from '../../actions/leaveAction';
import LeaveModal from './leaveModal';
import userStore from '../../stores/userStore';
import genFunction from '../../functions/genFunction';

class LeaveList extends React.Component {
    constructor(props) {
        super(props);
        this.onUserChange = this.onUserChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.showOption = this.showOption.bind(this);
        this.closeOption = this.closeOption.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            id: "",
            title: "",
            modalClose: false,
            action: "",
            leaveImage: "",
            staffId: "",

            permission: userStore.getState().permission,
            subordinate: userStore.getState().subordinate,
            userId: userStore.getState().staffId
        }
    }

    static defaultProps = {
        mthTxt: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        dayTxt: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"],
        statusTxt: ["Approved", "Rejected", "Cancelled", "Pending"],
        ampTxt: ["Full", "AM", "PM"],
    }
    componentDidMount() {
        userStore.listen(this.onUserChange);
        window.addEventListener("click", this.closeOption);
    }
    componentWillUnmount() {
        userStore.unlisten(this.onUserChange);
        window.removeEventListener("click", this.closeOption);
    }
    onUserChange(state) {
        this.setState({
            permission: state.permission,
            subordinate: state.subordinate,
            userId: state.staffId
        })
    }
    shouldModalClose() {
        this.setState({
            modalClose: false
        });
    }
    handleClick(e) {
        let action = parseInt(e.target.getAttribute('data-action'));
        let index = parseInt(e.target.getAttribute('data-index'));
        let staffId = e.target.getAttribute('data-staffid');
        let id = e.target.getAttribute('data-id');
        let leaveImage = "", receiptImage = "";
        let title;
        if (action == 0) {
            title = "Approve Leave";
        } else if (action == 1) {
            title = "Reject Leave";
        } else if (action == 2) {
            title = "Cancel Leave";
        } else if (action == 3) {
            title = "Upload MC"
        } else if (action == 4) {
            title = "Medical Certificate";
            leaveImage = this.props.leaves[index].leaveImage;
        } else if (action == 5) {
            title = "Receipt";
            receiptImage = this.props.leaves[index].receiptImage;
        } else if (action == 6) {
            title = "Upload Receipt";
        }
        this.setState({
            action: action,
            index: index,
            id: id,
            staffId: staffId,
            leaveImage: leaveImage,
            receiptImage: receiptImage,
            title: title,
            modalClose: true
        });
        if (action !== 4) {
            leaveAction.shouldListShow(index);
        }

    }
    handleSubmit(action, leaveImage) {
        if (action == 4 || action == 5) return this.setState({ modalClose: false });
        if (action != 3 && action != 6) {
            if (this.props.processing) return;

            leaveAction.processing(true);
            leaveAction.changeStatus(this.state.id, action, this.state.staffId);
        } else if (action == 3) {
            let fd = new FormData();
            fd.append("images", leaveImage);
            fd.append("_id", this.state.id);
            leaveAction.processing(true);
            leaveAction.uploadMC(this.state.id, fd);

        } else if (action == 6) {
            let fd = new FormData();
            fd.append("images", leaveImage);
            fd.append("_id", this.state.id);
            leaveAction.processing(true);
            leaveAction.uploadReceipt(this.state.id, fd);
        }

        this.setState({ modalClose: false });
    }
    showOption(e) {
        e.preventDefault();
        e.stopPropagation();

        let index = parseInt(e.target.getAttribute('data-index'));
        leaveAction.shouldListShow(index);
    }
    closeOption() {
        leaveAction.closeListShow();
    }
    renderDataList(leave, index) {
        leave.date = new Date(leave.date);
        leave.startDate = new Date(leave.startDate);
        leave.endDate = new Date(leave.endDate);
        let isSameDate, endDate, apmEnd;

        let date = leave.date.getDate() + "-" + this.props.mthTxt[leave.date.getMonth()] + "-" + leave.date.getFullYear();
        let day = this.props.dayTxt[leave.date.getDay()];
        let startDate = leave.startDate.getDate() + "-" + this.props.mthTxt[leave.startDate.getMonth()] + "-" + leave.startDate.getFullYear();
        if (leave.type != 7) {
            isSameDate = ((leave.endDate.getTime() - leave.startDate.getTime()) / 1000 / 60 / 60 / 24 + 1 <= 1);
            endDate = leave.endDate.getDate() + "-" + this.props.mthTxt[leave.endDate.getMonth()] + "-" + leave.endDate.getFullYear();
            apmEnd = isSameDate ? "-" : this.props.ampTxt[leave.apmEnd];

        } else {
            endDate = startDate;
        }
        let action = '';

        return (

            <tr key={index}>
                <td>{date}</td>
                <td>{day}</td>
                <td>{leave.submittedBy}</td>
                <td>{startDate} ({leave.type != 7 ? this.props.ampTxt[leave.apmStart] : leave.startTime})</td>
                <td>{endDate} ({leave.type != 7 ? apmEnd : leave.endTime})</td>
                <td>{leave.leaveTxt}</td>
                <td>{leave.duration}</td>
                <td>{this.props.statusTxt[leave.status]}</td>
                <td>{this.renderLeaveImg(index, leave)}</td>
                <td>{this.renderReceiptImg(index, leave)}</td>
                <td>{leave.remark ? leave.remark : "-"}</td>
                <td>
                    <span className="lv-edit glyphicon glyphicon-option-vertical" data-index={index} onClick={this.showOption}></span>
                    {this.renderEdit(index, leave)}
                </td>
            </tr>

        );

    }
    renderLeaveImg(index, leave) {

        if (leave.leaveImage != null && leave.leaveImage != "") {
            return (<a data-action="4" data-id={leave._id} data-index={index} onClick={this.handleClick}>Medical Certificate</a>);
        } else {
            return (<div>-</div>);
        }
    }
    renderReceiptImg(index, leave) {
        if (leave.receiptImage != null && leave.receiptImage != "") {
            return (<a data-action="5" data-id={leave._id} data-index={index} onClick={this.handleClick}>View Receipt</a>);
        } else {
            return (<div>-</div>);
        }
    }
    renderEdit(index, leave) {
        let statusOption = [];

        if ((genFunction.hasPermission(this.state.permission, 2) && leave.staffId != this.state.userId) ||
            genFunction.isSubordinate(this.state.subordinate, leave.staffId)) {
            //if date adi expire, should be approve 
            statusOption = [
                <li data-action="0" key={0} data-staffid={leave.staffId} data-id={leave._id} data-index={index} onClick={this.handleClick}>Approve</li>,
                <li data-action="1" key={1} data-staffid={leave.staffId} data-id={leave._id} data-index={index} onClick={this.handleClick}>Reject</li>,
            ];
        }
        if (genFunction.hasPermission(this.state.permission, 2) ||
            (leave.staffId == this.state.userId && new Date(leave.startDate).getTime() > new Date().getTime()) ||
            (leave.staffId == this.state.userId && leave.status == 3) ||
            genFunction.isSubordinate(this.state.subordinate, leave.staffId)) {

            statusOption = statusOption.concat(
                <li data-action="2" key={2} data-staffid={leave.staffId} data-id={leave._id} data-index={index} onClick={this.handleClick}>Cancel</li>
            );

        }
        if (leave.type == 1 && (leave.status == 3 || leave.status == 0) &&
            (genFunction.hasPermission(this.state.permission, 2) || leave.staffId == this.state.userId ||
            genFunction.isSubordinate(this.state.subordinate, leave.staffId))) {
            statusOption = statusOption.concat(
                <li data-action="3" key={3} data-staffid={leave.staffId} data-id={leave._id} data-index={index} onClick={this.handleClick}>Upload MC</li>
            );
            statusOption = statusOption.concat(
                <li data-action="6" key={6} data-staffid={leave.staffId} data-id={leave._id} data-index={index} onClick={this.handleClick}>Upload Receipt</li>
            );
        }
        return (
            <ul className={"lv-dropdown " + (leave.shouldListShow ? "lv-show" : "lv-hide")} >
                {statusOption}
            </ul>
        );

    }
    renderMainList() {

        return this.props.leaves.map((leave, index) => {
            return (
                this.renderDataList(leave, index)
            );
        });
    }

    render() {

        return (
            <div className="atd-abd-wp">
                <div className="atd-em-lt">
                    <table className="leave-tb">
                        <tbody className={"leave-tbd"}>
                            {this.renderMainList()}
                        </tbody>
                    </table>
                </div>
                <LeaveModal
                    modalClose={this.state.modalClose}
                    shouldModalClose={this.shouldModalClose}
                    title={this.state.title}
                    action={this.state.action}
                    leaveImage={this.state.leaveImage}
                    receiptImage={this.state.receiptImage}
                    callBack={this.handleSubmit}
                />
            </div>
        );
    }
}
export default LeaveList;


// WEBPACK FOOTER //
// ./app/components/leaveComponents/leaveList.js